<template>
    <div class="m-pay">
        <h5 class="title"></h5>
        <div class="slogen">活动期间，本人累计充值相应金额，即可解锁梦玩团福袋</div>
        <div class="page-detail">
            <div class="pay-view">
                <div class="pro-bar">
                    <div class="rate" :style="{'width' : rate[$store.state.task[tid].finishRate] + '%'}"></div>
                </div>

                <div class="pay-list">
                    <div class="pay-item" v-for="(item,index) in $store.state.task[tid].subList" :key="'p-' + (index + 1)">
                        <div class="pack" :class="{'active' : index < $store.state.task[tid].finishRate}">
                            <div class="circel"></div>
                            <div class="pack-img" :class="'p-'+ (index + 1)"></div>
                        </div>

                        <div class="require">
                            <p>本人累计充值</p>
                            <p class="cnt">{{ item.value / 10 }}元</p>
                        </div>

                        <div class="reward-pannel">
                            <h6 :class="'p-' + (index + 1)"></h6>

                            <div class="reward-list">
                                <ul>
                                    <li v-for="(r,k) in gift_config[index]" :key="'r-'+ (index + 1) + k">
                                        <div class="reward-item" v-tips="r.id"><game-item :locked="true" :id="r.id" :num="r.send_num"></game-item></div>
                                    </li>
                                </ul>
                            </div>

                            <div class="status complete" v-if="index < $store.state.task[tid].giftRate"></div>
                            <div class="status goal" v-if="index < $store.state.task[tid].finishRate && index >= $store.state.task[tid].giftRate"></div>
                        </div>
                    </div>
                </div>

                <div class="u-btn apply" @click="apply($store.state.task[tid].taskOrderId)"></div>
            </div>

            
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){

    .title{
        margin: 0 auto;

        @if ( $screenWidth == 1600) {
            width: 799px;
            height: 148px;
            background-image: url(~@/assets/images/pc/title-2.png);
        }@else if( $screenWidth == 1000 ) {
            width: 750px;
            height: 148px;
            background-image: url(~@/assets/images/m/title-2.png);
        }         
    }

    .pay-view{

        position: relative;

        .require{
            text-align: center;

            .cnt{
                font-family: 'HYJinKaiJ';
                font-size: 26px;
                color: #c2393f;
            }
        }
        @if ( $screenWidth == 1600) {
            margin-top: 32px;

            .u-btn.apply{
                width: 207px;
                height: 55px;
                margin: 60px auto 0;
                background-image: url(~@/assets/images/pc/btn-apply-all.png);

                &:hover{
                    background-image: url(~@/assets/images/pc/btn-apply-all_hover.png);
                }
            }            

            .pro-bar{
                position: absolute;
                left: 50%;
                top: 60px;
                transform: translateX(-50%);
                width: 100%;
                height: 6px;
                border-radius: 3px;
                background-color: #e6ddcc;
                
                .rate{
                    height: 100%;
                    border-radius: 3px;
                    background-color: #c2393f;                    
                }
            }

            .pay-list{
                position: relative;
                display: flex;
                justify-content: space-between;

                .pack{
                    position: relative;
                    width: 125px;
                    height: 124px;
                    margin: 0 auto;
                    background-image: url(~@/assets/images/pc/pack_normal.png);
                    background-position: center;
                    background-repeat: no-repeat;

                    &:hover{
                        background-image: url(~@/assets/images/pc/pack_hover.png);
                    }

                    &.active{
                        background-image: url(~@/assets/images/pc/pack_active.png);
                        
                        @for $i from 1 through 4{
                            & .p-#{$i} {
                                background-image: url(~@/assets/images/pc/pack-#{$i}.png);
                            }
                        }                           
                    }

                    .pack-img{
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        width: 54px;
                        height: 59px;
                        transform: translate(-50%,-50%);
                        margin-top: -3px;
                        background-image: url(~@/assets/images/pc/pack.png);                     
                    }
                }
            }

            .reward-pannel{
                position: relative;
                width: 249px;
                height: 251px;
                margin: 12px auto 0;
                padding-top: 13px;
                box-sizing: border-box;
                background-image: url(~@/assets/images/pc/buy-pannel.png);

                h6{
                    width: 216px;
                    height: 29px;
                    margin: 0 auto 0;

                    @for $i from 1 through 4{
                        &.p-#{$i} {
                            background-image: url(~@/assets/images/pc/p-#{$i}.png);
                        }
                    }
                }

                .status.complete{
                    position: absolute;
                    left: 50%;
                    bottom: -20px;
                    width: 107px;
                    height: 57px;
                    transform: translateX(-50%);
                    background-image: url(~@/assets/images/pc/status_active-ling-pc.png);
                }

                .status.goal{
                    position: absolute;
                    left: 50%;
                    bottom: -20px;
                    width: 107px;
                    height: 57px;
                    transform: translateX(-50%);
                    background-image: url(~@/assets/images/pc/status_active.png);
                }                

                .reward-list{

                    padding: 0 48px;

                    ul{
                        display: flex;
                        justify-content: space-between;
                        flex-wrap: wrap;
                    }

                    li{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 64px;
                        height: 64px;
                        margin-top: 18px;
                        border: 1px solid #d1c7b4;
                        background-color: #e6ddcc;
                    }

                    .reward-item{
                        width: 46px;
                        height: 46px;
                    }
                }
            }

        }@else if( $screenWidth == 1000 ) {
            .u-btn.apply{
                width: 310px;
                height: 82px;
                margin: 60px auto 0;
                background-image: url(~@/assets/images/m/btn-apply-all.png);
            }            

            .pro-bar{
                position: absolute;
                left: 50%;
                top: 60px;
                transform: translateX(-50%);
                width: 710px;
                height: 5px;
                border-radius: 3px;
                background-color: #e6ddcc;
                
                .rate{
                    height: 100%;
                    border-radius: 3px;
                    background-color: #c2393f;                    
                }
            }

            .pay-list{
                position: relative;
                display: flex;
                justify-content: space-between;

                .pack{
                    position: relative;
                    width: 125px;
                    height: 124px;
                    margin: 0 auto;
                    background-image: url(~@/assets/images/pc/pack_normal.png);
                    background-position: center;
                    background-repeat: no-repeat;

                    .pack-img{
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        width: 54px;
                        height: 59px;
                        transform: translate(-50%,-50%);
                        margin-top: -3px;
                        background-image: url(~@/assets/images/pc/pack.png);                     
                    }

                    &.active {
                        background-image: url(~@/assets/images/pc/pack_active.png);


                        @for $i from 1 through 4{
                            & .p-#{$i} {
                                background-image: url(~@/assets/images/pc/pack-#{$i}.png);
                            }
                        }                           
                    }                    
                }
            }

            .reward-pannel{
                position: relative;
                width: 169px;
                height: 451px;
                margin: 12px auto 0;
                padding-top: 13px;
                box-sizing: border-box;
                background-image: url(~@/assets/images/m/buy-pannel.png);

                h6{
                    width: 95px;
                    height: 62px;
                    margin: 0 auto 15px;
                    background-position: top center;
                    background-repeat: no-repeat;

                    @for $i from 1 through 4{
                        &.p-#{$i} {
                            background-image: url(~@/assets/images/m/p-#{$i}.png);
                        }
                    }
                }


                .status.complete{
                    position: absolute;
                    left: 50%;
                    bottom: -30px;
                    width: 139px;
                    height: 73px;
                    transform: translateX(-50%);
                    background-image: url(~@/assets/images/m/status_active-ling-app.png);
                }

                .status.goal{
                    position: absolute;
                    left: 50%;
                    bottom: -30px;
                    width: 139px;
                    height: 73px;
                    transform: translateX(-50%);
                    background-image: url(~@/assets/images/m/status_active.png);
                }                

                .reward-list{

                    

                    ul{
                        width: 69px;
                        margin: 0 auto;
                        padding: 0 9px 9px 9px;
                        border: 1px solid #d1c7b4;
                        background-color: #e6ddcc;
                        box-sizing: content-box;                       
                    }

                    li{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-top: 9px;
                        border: 1px solid #d1c7b4;
                        background-color: #e6ddcc;
                    }

                    .reward-item{
                        width: 69px;
                        height: 69px;
                    }
                }
            }
        }             
    }
    


    @if ( $screenWidth == 1600) {

    }@else if( $screenWidth == 1000 ) {

    }    

}

@media screen and (min-width: 1000px){
@include boxStyle( 1600 );
}
@media screen and (min-width: 375px) and (max-width: 999px){
@include boxStyle( 1000 );
}
</style>

<script>
export default {
    data (){
        return {
            tid : 't03',
            gift_config : [
                [
                    {"id":"F887","item_name":"封灵玉碎片(30天)","send_num":100},
                    {"id":"KR48","item_name":"活跃自选礼包（7天）","send_num":5},
                    {"id":"X230","item_name":"征战印记(30天)","send_num":50},
                    {"id":"AM99","item_name":"会员（7天）","send_num":1},                    
                ],
                [
                    {"id":"F887","item_name":"封灵玉碎片(30天)","send_num":200},
                    {"id":"D774","item_name":"暗金珍材自选宝箱","send_num":5},
                    {"id":"E559","item_name":"十万个人士兵","send_num":5},
                    {"id":"KW99","item_name":"空相宝莲","send_num":10},                    
                ],
                [
                    {"id":"KW61","item_name":"金色封灵玉自选包(7天)","send_num":1},
                    {"id":"E559","item_name":"十万个人士兵","send_num":5},
                    {"id":"LY49","item_name":"武器升级珍材自选包","send_num":10},
                    {"id":"D774","item_name":"暗金珍材自选宝箱","send_num":10},                    
                ],
                [
                    {"id":"D847","item_name":"自选珍宝宠物蛋（7天）","send_num":2},
                    {"id":"E560","item_name":"一百万个人士兵","send_num":1},
                    {"id":"X567","item_name":"蕴灵小鱼干","send_num":15},
                    {"id":"F280","item_name":"四象仙丹","send_num":5},                    
                ],
            ],
            rate : [0,12,40,65,100],
        }
    },
    computed:{
        aid (){
            return this.$store.state.userinfo.areaId;
        },
    },
    watch: {
        aid: {
            handler(newVal, oldVal) {
                //todo      
            },
            deep: true
        },        
    },        
    methods : {
        apply (tid){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.areaId){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            if(!tid){
                return this.$toast('请先完成任务');
            }

            let index = Math.min (this.$store.state.task[this.tid].finishRate - 1 , this.gift_config.length - 1);
            let total = (this.$store.state.task[this.tid].finishRate - this.$store.state.task[this.tid].giftRate) * 4;
            let list = this.gift_config[index];

            //this.$reward_success({'text' : total + '个奖励已发放至军师邮箱，领取详情请查看活动首页' , giftList : list});

            this.$axios.post(ajax_url_map.apply_task,{
                no : tid
            })
            .then(
                res => {
                    this.$reward_success({'text' : total + '个奖励已发放至军师邮箱，领取详情请查看活动首页' , giftList : list});
                    this.$task_render();
                },
                rej => {
                    this.$toast(rej.message);
                }
            )            
        },        
    }
}
</script>


// WEBPACK FOOTER //
// src/views/pay.vue